<template>
  <div class="new-carrier__box">
    <sc-icon icon="box-open"></sc-icon>
    <p class="new-carrier__title">Não encontrou a transportadora?</p>
    <p>Preencha o formulário para nossa equipe te ajudar na integração</p>
    <sc-button 
      text="Adicionar nova transportadora" 
      class="new-carrier__button"
      @click="openForm()" 
      theme="primary" 
      type="button"/>
  </div>
</template>

<script>
import { ScButton, ScIcon } from '@intelipost-js/secure-components';

export default {
  name: 'integration-self-service-btn-carrier',

  components: {
    ScButton,
    ScIcon,
  },
  methods: {
    openForm() {
      this.$router.push({ name: 'new-logistic-provider-form' });
    },
  },

};
</script>
<style lang='scss'>
@import "~@intelipost-js/secure-ui/src/scss/variables";

.new-carrier {
  &__title {
    font-size: 1.5rem;
    font-weight: bold;
    margin-bottom: 5px;
  }
  &__button {
    padding: 20px;
    margin-top: 15px;
  } 
  &__box {
    text-align: center;
  }

}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/features/integrations-app-self-service/components/app-list/btn-add-new-carrier/BtnAddNewCarrier.vue